module.exports = __webpack_public_path__ + "img/fremont.26fe2edd.png";